import React, { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useKeyWordsModel } from "../keyWordsModel";
import { YhBut } from "@/components/YhButton";
import { IKerwordsDetails } from "../keyWordsService";


export function DataTable1() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, updataKeyWords, setKeyWordsDrawer, removeKeyWords
    } = useKeyWordsModel();

    const columns: ColumnsType<IKerwordsDetails> = [
        {
            title: "序号",
            width: 100,
            align: "center",
            render: (text, record, index) => index + 1
        },
        {
            title: '关键词名称',
            align: "center",
            dataIndex: 'name',
        },
        {
            title: '所属分类',
            width: 350,
            align: "center",
            dataIndex: 'keywordTypeName',
        },
        {
            title: '权重',
            width: 350,
            align: "center",
            dataIndex: 'weight',
        },
        {
            title: '状态',
            align: "center",
            dataIndex: 'status',
            className: "td-wrap",
            render: (text, record) => (
                <Switch
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    checked={+record.status ? true : false}
                    onChange={(checked: boolean, e: MouseEvent) => {
                        let { id, name, weight, keywordTypeId, keywordTypeName } = record;
                        e.stopPropagation();
                        updataKeyWords({ id, name, weight, keywordTypeId, keywordTypeName, status: checked ? 1 : 0 }, checked ? "启用成功" : "禁用成功");
                    }}
                />
            ),
        },
        {
            title: '操作',
            width: 200,
            align: "center",
            className: "td-wrap",
            render: (txt, record) => <>
                <YhBut
                    type="edit"
                    txt="编辑"
                    click={() => {
                        setSelectedRowKeys([record]);
                        setKeyWordsDrawer({ visible: true, mode: "edit" })
                    }}
                />
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeKeyWords(record.id)}
                />
            </>
        }
    ];


    useEffect(() => {
        loadData();
    }, [])

    return (
        <Table
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: event => setSelectedRowKeys(selectedRowKeys === record.id ? "" : record.id)
            // })}
            // rowClassName={(record, index) => record.id === selectedRowKeys ? "table-select-row" : ""}
            scroll={{ x: 'max-content', }}
        />
    )
}
